import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ikas from "../../providers/ikas";
import config from "../../config";

const fulfillmentStatusMap = {
  FULFILLED: {
    text: "Teslim Edildi",
    className: "bg-green-100 text-green-700",
  },
  PENDING: { text: "Bekliyor", className: "bg-yellow-100 text-yellow-700" },
  CANCELLED: { text: "İptal Edildi", className: "bg-red-100 text-red-700" },
  CREATED: { text: "Oluşturuldu", className: "bg-blue-100 text-blue-700" },
  DRAFT: { text: "Taslak", className: "bg-gray-100 text-gray-700" },
  PARTIALLY_CANCELLED: {
    text: "Kısmen İptal",
    className: "bg-orange-100 text-orange-700",
  },
  PARTIALLY_REFUNDED: {
    text: "Kısmen İade",
    className: "bg-orange-100 text-orange-700",
  },
  REFUNDED: { text: "İade Edildi", className: "bg-purple-100 text-purple-700" },
  REFUND_REJECTED: {
    text: "İade Reddedildi",
    className: "bg-red-100 text-red-700",
  },
  REFUND_REQUESTED: {
    text: "İade Talebi",
    className: "bg-yellow-100 text-yellow-700",
  },
  WAITING_UPSELL_ACTION: {
    text: "Ek Satış Bekliyor",
    className: "bg-blue-100 text-blue-700",
  },
  default: { text: "Bilinmiyor", className: "bg-gray-200 text-gray-600" },
};

export default function Orders({ data, dataSetter }) {
  const [loading, setLoading] = useState(true);
  const orders = data?.orders;
  const navigate = useNavigate();

  const onOrderClick = (order) => {
    navigate(`/account/order`, {
      state: { order },
    });
  };
  const getOrders = async () => {
    try {
      const res = await ikas.getCustomerOrders();
      dataSetter(res);
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <span className="w-12 h-12 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></span>
      </div>
    );
  }

  return (
    <div>
      {!orders || orders.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="30" stroke="#e4e4e4" strokeWidth="4" />
            <path
              d="M44 44L54 54"
              stroke="#bdbdbd"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <circle cx="30" cy="30" r="12" stroke="#bdbdbd" strokeWidth="3" />
          </svg>
          <div className="mt-4 text-lg font-semibold text-gray-700 text-center">
            Sipariş bulunamadı
          </div>
          <div className="text-sm text-gray-400 mt-1 text-center">
            Henüz hiç siparişiniz yok.
            <br />
            Alışveriş yaparak ilk siparişinizi oluşturabilirsiniz.
          </div>
        </div>
      ) : (
        <div className="w-full max-w-md min-w-[200px] flex flex-col gap-5 p-2 mx-auto">
          {orders.map((order, index) => (
            <div
              onClick={() => onOrderClick(order)}
              key={index}
              className="w-full flex bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 overflow-hidden cursor-pointer"
            >
              <div className="flex flex-col items-center justify-center min-w-[80px] bg-gray-50 p-2">
                <img
                  src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${order.orderLineItems[0].variant.mainImageId}/image_540.webp`}
                  alt={order.orderLineItems[0].variant.name}
                  className="w-16 h-16 object-cover rounded-md border border-gray-200"
                />
                <span
                  className={`mt-3 px-2 py-1 text-xs font-semibold rounded-full ${
                    (
                      fulfillmentStatusMap[order.status] ||
                      fulfillmentStatusMap.default
                    ).className
                  }`}
                >
                  {
                    (
                      fulfillmentStatusMap[order.status] ||
                      fulfillmentStatusMap.default
                    ).text
                  }
                </span>
              </div>
              <div className="flex-1 flex flex-col justify-between p-3 gap-2">
                <div className="flex items-center justify-between">
                  <h3 className="text-base font-bold text-gray-800">
                    {order.orderNumber}
                  </h3>
                  <span className="text-sm font-semibold text-indigo-700 bg-indigo-50 px-2 py-1 rounded">
                    {order.currencySymbol} {order.totalFinalPrice}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mb-1">
                  {new Date(order.createdAt).toLocaleDateString("tr-TR", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
                <div>
                  <div className="text-xs text-gray-700 font-medium mb-1">
                    Ürünler:
                  </div>
                  <ul className="flex flex-col gap-1">
                    {order.orderLineItems.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="flex items-center gap-2 text-sm text-gray-700"
                      >
                        <span className="font-medium">{item.variant.name}</span>
                        <span className="text-xs text-gray-400">
                          x{item.quantity}
                        </span>
                        <span className="ml-auto text-xs text-gray-500">
                          {item.variant.prices.currencySymbol}{" "}
                          {item.variant.prices.buyPrice}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
